import React from "react"
import IndexStyles from "./index.less"
import {connect} from "react-redux"
import {Props, State} from "../../util/interfaceData"
import NoDataBody from "../body/noDataBody"
import HasDataBody from "../body/hasDataBody"
import {modelTestInit, modelTestUpdate} from "../action/action"
import testData from "../../../src/componets/有表格.json"
import classNames from "classnames"
import Jsonviewer from "../jsonviewer"
import Mdviewer from "../mdviewer"

// eslint-disable-next-line react/prefer-stateless-function
class ModelTest extends React.Component<Props, State, {}> {
    constructor(props: Props) {
        super(props)
    }

    jsonView = (<Jsonviewer />)

    getPageLabelData = () => {
        const getResult =
            this.props.recognitionArea.length +
                this.props.normalTableJson.length +
                this.props.table.length +
                this.props.errorField.length ===
            0 ? (
                // eslint-disable-next-line react/jsx-indent
                <NoDataBody />
            ) : (
                <HasDataBody />
            )
        switch (this.props.pageLabel) {
            case "result":
                return this.props.recognitionArea.length +
                    this.props.normalTableJson.length +
                    this.props.table.length +
                    this.props.errorField.length ===
                    0 ? (
                    // eslint-disable-next-line react/jsx-indent
                    <NoDataBody />
                ) : (
                    <HasDataBody />
                )
            case "json":
                return this.jsonView
            default:
                return <Mdviewer />
        }
        // return (
        //     <React.Fragment>
        //         {getResult}
        //         <Jsonviewer />
        //         <Mdviewer />
        //     </React.Fragment>
        // )
    }

    render() {
        const showTag = this.getPageLabelData()

        return (
            <div className={IndexStyles.modelTestBox}>
                <div className={IndexStyles.subject}>
                    <div className={IndexStyles.modelTestNav}>
                        <div
                            className={classNames(IndexStyles.navTitleBtn, {
                                [IndexStyles.navTitleBtnActive]: this.props.pageLabel === "result",
                            })}
                            onClick={() => {
                                this.props.dispatch({type: "setPageLabel", payload: "result"})
                            }}
                        >
                            识别结果
                        </div>
                        <div
                            className={classNames(IndexStyles.navTitleBtn, {
                                [IndexStyles.navTitleBtnActive]: this.props.pageLabel === "json",
                            })}
                            onClick={() => {
                                this.props.dispatch({type: "setPageLabel", payload: "json"})
                            }}
                        >
                            JSON
                        </div>
                        <div
                            className={classNames(IndexStyles.navTitleBtn, {
                                [IndexStyles.navTitleBtnActive]: this.props.pageLabel === "md",
                            })}
                            onClick={() => {
                                this.props.dispatch({type: "setPageLabel", payload: "md"})
                            }}
                        >
                            调用示例
                        </div>
                    </div>
                    <div className={IndexStyles.allMessage1}>{showTag}</div>
                </div>
            </div>
        )
    }
}

export default connect((state: any) => {
    return {
        normalTableJson: state.normalTableJson,
        pageLabel: state.pageLabel,
        recognitionArea: state.recognitionArea,
        errorField: state.errorField,
        table: state.table,
    }
})(ModelTest)
